import axios from 'axios';
import { merge } from 'lodash';
import to from 'await-to-js';
import resources from '@enums/resources';
import storeMixin from '@/js/store/mixins/vuex-store';
import i18n from '../../vue-i18n';

const { productCosts: productCostsEnum } = resources;
/**
 * Inherits from the default store mixin which takes care of all CRUD operations.
 */
const store = {
    namespaced: true,

    /**
     * Default state available:
     * - loading
     */
    state: {
        productCosts: [],
    },

    /**
     * Default getters available:
     * - getProductCostById
     * - getFilteredProductCosts
     */
    getters: {},

    /**
     * Default mutations available:
     */
    mutations: {},

    /**
     * Default actions available:
     *
     * - handleResponseNotifications
     */
    actions: {
        async fetchProductCosts({ dispatch }, { params }) {
            // Call Product costs API for product.
            const [error, response] = await to(
                axios.post('/api/product-costs/for-promotion', params)
            );
            if (error) {
                return dispatch('handleResponseNotifications', {
                    error,
                    errorMessage: i18n.t('notifications.fetchError', {
                        resource: productCostsEnum,
                    }),
                });
            }

            const productCosts = response.data;

            return productCosts;
        },
    },
};

const mixinParams = {
    resource: 'product-costs',
    readOnly: true,
};

export default merge({}, storeMixin(mixinParams), store);
